import React from 'react';
import {
  HeroHeaderSkeleton,
  RunHistoryTableSkeleton,
  SectionSkeleton,
  StageRailSkeleton,
  StatStripSkeleton
} from './blocks';

const AzureMLDetailSkeleton: React.FC = () => (
  <>
    <HeroHeaderSkeleton />
    <StatStripSkeleton tiles={2} />
    <SectionSkeleton titleWidth={50}>
      <StageRailSkeleton stages={5} />
    </SectionSkeleton>
    <SectionSkeleton titleWidth={90}>
      <RunHistoryTableSkeleton rows={5} />
    </SectionSkeleton>
  </>
);

export default AzureMLDetailSkeleton;
